import { Box, Col, Collapse, Container, Icon, Row, themes } from '@digitools/honest-react';
import useDentalDataContext from 'src/packages/dental/hooks/useDentalContext';
import { getMemberEvent, tealiumFormat, } from 'src/packages/dental/providers/DentalDataProvider';
import React from 'react';
import useTranslate from 'src/hooks/useTranslate';
import DentalText from 'src/packages/dental/constants/DentalText';
import { DentalSubHeading, ErrorHtml } from 'src/packages/dental/Dental';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
import { useMediaQuery } from '@mantine/hooks';
const BenefitFrequencyTables = () => {
    const isTitleView = useMediaQuery('(max-width: 780px)');
    const CollapsedIcon = () => (<Icon name='add' size='xs' className='align-content-center p-3' color='primary'/>);
    const ExpandedIcon = () => (<Icon name='subtract' size='xs' className='align-content-center p-3' color='primary'/>);
    const BenefitFreqTable = ({ benefits, title, image, waitingPeriod, hasWaitingPeriodError, }) => {
        const { t } = useTranslate();
        // The waiting period table ordered (waitingPeriodOrder) only displays if "allMet" is null or undefined
        let waitingPeriodOrder = [];
        const addKeyPairWithLabels = (keyPair) => {
            if (keyPair && keyPair.label != null && keyPair.label !== '') {
                waitingPeriodOrder?.push(keyPair);
            }
        };
        if (waitingPeriod?.allMet == null) {
            [
                waitingPeriod?.waitingPeriod,
                waitingPeriod?.waitingPeriodMet,
                waitingPeriod?.entrantLimit,
                waitingPeriod?.entrantLimitMet,
            ].forEach(val => addKeyPairWithLabels(val));
        }
        const showWaitingPeriod = hasWaitingPeriodError || waitingPeriodOrder.length || waitingPeriod?.allMet;
        return (<Box className={'mt-3'} onClick={(event) => {
                const button = event.currentTarget.querySelector('button[aria-expanded]');
                if (button?.getAttribute('aria-expanded') === 'false') {
                    trackDropdownEvent(title || '');
                }
            }} data-public={true}>
        <Collapse data-testid={'outer-collapse-benefits' + title} titleComponent={() => (<div className={'h-100 d-flex align-items-center'}>
              <DentalSubHeading text={title} isTitleView={isTitleView} color={'secondaryDark'}/>
            </div>)} headerElemType={isTitleView ? 'h4' : 'h2'} headerElemStyle={'h2'} isOpen={false} role={'button'} expandedIcon={ExpandedIcon} collapsedIcon={CollapsedIcon} theme={themes.rebrand} type='alternate' color={'white'} headerLeftDisplay={() => (<Icon size={'xl'} name={image} className={'text-center'} style={{ width: '25px' }} color='primary'/>)}>
          {showWaitingPeriod && (<Container className={'pl-0 pr-0'}>
              <Row>
                {hasWaitingPeriodError && (<Col className={'mb-2'}>
                    <ErrorHtml errorType={currentMember?.waitingPeriodsError} generalErrorMessage={`${t(DentalText.waitingPeriodGeneralError)}`} notFoundErrorMessage={t(DentalText.waitingPeriodNotFoundError)}/>
                  </Col>)}
                {waitingPeriod?.allMet && (<Col className={'mb-4 mt-2'}>
                    <Icon className={'ml-3 align-middle'} size='medium' name='info' color={'secondary'} title={'deductibles info'}/>
                    <div className={'d-inline ml-2'}>{waitingPeriod.allMet}</div>
                  </Col>)}
                {!hasWaitingPeriodError &&
                    !!waitingPeriodOrder.length &&
                    waitingPeriodOrder.map(benefit => (<>
                      {benefit && (<Col md={6} xs={12} className={''}>
                          <Row>
                            <Col className={'m-2 bg-light w-100 pt-2 pb-2'} style={{ fontWeight: '500' }}>{benefit?.label}</Col>
                          </Row>
                          <Row className={'mt-1 mb-1 ml-0 mr-0 pb-3'}>
                            <Col className={'w-100 border-danger'} style={{ border: 'solid', borderWidth: '0 0 2px 0' }}>
                              {benefit?.value}
                            </Col>
                          </Row>
                        </Col>)}
                    </>))}
              </Row>
            </Container>)}
          {benefits &&
                benefits.map((item) => (<Collapse title={item.serviceName} type={'alternate'} data-testid={'inner-collapse-benefits'} style={{ paddingBottom: '1rem' }}>
                {item.details && item.details.length !== 0 && (<Box style={{ border: 0, paddingTop: '1rem', marginBottom: '.5rem', marginTop: 0 }} color={'grayLightest'} data-testid={'details-box'}>
                    <Col>
                      <Row>
                        <Col className={'pl-0 pr-0'} style={{ fontWeight: '500' }}>{t(DentalText.details)}</Col>
                      </Row>
                      {item.details.map((detail) => (<Row className={'font-weight-light'}>{detail}</Row>))}
                    </Col>
                  </Box>)}
                <Box style={{ border: 0, paddingTop: 0 }}>
                  {item.frequency != null && item.frequency != '' && (<Row className={'border-bottom pb-2'}>
                      <Col style={{ fontWeight: '500' }}>
                        {t(DentalText.frequency)}
                      </Col>
                      <Col>
                        <p className={'text-right font-weight-light w-100'}>{item.frequency}</p>
                      </Col>
                    </Row>)}
                  {item.ageLimit != null && item.ageLimit != '' && (<Row className={'border-bottom pb-2'}>
                      <Col style={{ fontWeight: '500' }}>
                        {t(DentalText.ageLimit)}
                      </Col>
                      <Col>
                        <p className={'text-right font-weight-light w-100'}>{item.ageLimit}</p>
                      </Col>
                    </Row>)}
                  {item.additionalInfo && (<Row className={'border-bottom font-weight-bold pb-2'}>
                      <Col classname={'text-left'} style={{ fontWeight: '500' }}>
                        {t(DentalText.additionalInfo)}
                        <Row className={'font-weight-light'} style={{ paddingLeft: '.5rem' }}>
                          {item.additionalInfo}
                        </Row>
                      </Col>
                    </Row>)}
                </Box>
              </Collapse>))}
        </Collapse>
      </Box>);
    };
    const { currentMember, tealiumFunction, subscriber } = useDentalDataContext();
    const { t } = useTranslate();
    const memberEvent = getMemberEvent(currentMember, subscriber);
    const benefitsAndFrequencies = currentMember?.benefitsAndFrequencies;
    const preventiveServicesBenefits = benefitsAndFrequencies?.preventiveServices;
    const basicServicesBenefits = benefitsAndFrequencies?.basicServices;
    const majorServicesBenefits = benefitsAndFrequencies?.majorServices;
    const orthodontiaBenefits = benefitsAndFrequencies?.orthodontia;
    const waitingPeriods = currentMember?.waitingPeriods || [];
    const trackDropdownEvent = (eventName) => tealiumFunction({
        eventAction: TEALIUM_EVENT.EVENT_ACTION.EXPAND,
        eventName: tealiumFormat(`${eventName}`),
        eventType: 'covered services',
        memberEvent: memberEvent,
    });
    const getWaitingPeriod = (serviceCategory) => {
        return ((waitingPeriods.length &&
            waitingPeriods.find(waitingPeriod => waitingPeriod.serviceCategory?.valueOf() === serviceCategory)) ||
            undefined);
    };
    if (currentMember?.benefitsError) {
        return (<ErrorHtml errorType={currentMember?.benefitsError} generalErrorMessage={t(DentalText.benefitsAndFrequencyGeneralError)} notFoundErrorMessage={t(DentalText.benefitsAndFrequencyNotFoundError)}/>);
    }
    return (<>
      {!!preventiveServicesBenefits && preventiveServicesBenefits.length !== 0 && (<BenefitFreqTable benefits={preventiveServicesBenefits} waitingPeriod={getWaitingPeriod('TYPE_1')} hasWaitingPeriodError={!waitingPeriods.length} title={t(DentalText.preventiveServices)} image={'toothpaste'}/>)}
      {!!basicServicesBenefits && basicServicesBenefits.length !== 0 && (<BenefitFreqTable benefits={basicServicesBenefits} waitingPeriod={getWaitingPeriod('TYPE_2')} hasWaitingPeriodError={!waitingPeriods.length} title={t(DentalText.basicServices)} image={'drill'}/>)}
      {!!majorServicesBenefits && majorServicesBenefits.length !== 0 && (<BenefitFreqTable benefits={majorServicesBenefits} waitingPeriod={getWaitingPeriod('TYPE_3')} hasWaitingPeriodError={!waitingPeriods.length} title={t(DentalText.majorServices)} image={'instruments'}/>)}
      {!!orthodontiaBenefits && orthodontiaBenefits.length !== 0 && (<BenefitFreqTable benefits={orthodontiaBenefits} waitingPeriod={getWaitingPeriod('TYPE_4')} hasWaitingPeriodError={!waitingPeriods.length} title={t(DentalText.orthodontia)} image={'tooth1'}/>)}
    </>);
};
export default BenefitFrequencyTables;
